export default __webpack_public_path__ + "static/083-099496975d045019ff8f0ca89bcfc86b.jpg";